import { FC } from 'react';

import { LinkButton } from '@rikstv/play-common/src/components/linkButton/LinkButton';
import { Body } from '@rikstv/shared-components';

import { StrimStartPageResponse } from '../../../../apis/sanityClient';

import { ReactComponent as SP1Svg } from './sellingpoint1.svg';
import { ReactComponent as SP2Svg } from './sellingpoint2.svg';
import { ReactComponent as SP3Svg } from './sellingpoint3.svg';

import styles from './Sellingpoints.module.css';

export const SellingPoints: FC<{ data: StrimStartPageResponse }> = ({ data }) => {
  if (!data.sellingPoints) {
    return null;
  }

  const sellingPoints = [data.sellingPoints.argument1, data.sellingPoints.argument2, data.sellingPoints.argument3];
  const tertiaryCTA = data.tertiaryCTA;

  return (
    <>
      <div className={styles.sellingpoints}>
        <div className={styles.first}>
          <SP1Svg aria-hidden="true" />
          <Body lookLike="sub-title-2">{sellingPoints[0]}</Body>
        </div>
        <div className={styles.second}>
          <SP2Svg aria-hidden="true" />
          <Body lookLike="sub-title-2">{sellingPoints[1]}</Body>
        </div>
        <div className={styles.third}>
          <SP3Svg aria-hidden="true" />
          <Body lookLike="sub-title-2">{sellingPoints[2]}</Body>
        </div>
      </div>
      <div className={styles.button}>
        {tertiaryCTA && (
          <LinkButton withArrow buttonStyle="highlighted" to={tertiaryCTA.link}>
            {tertiaryCTA.text}
          </LinkButton>
        )}
      </div>
    </>
  );
};
